


import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { BsFacebook, BsTwitterX, BsLinkedin, BsInstagram, BsWhatsapp } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-teal-900 to-teal-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12">

          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-2">
              <span className="text-4xl animate-pulse text-teal-300">⚕️</span> 
              <h2 className="text-2xl md:text-3xl font-bold tracking-wider text-teal-50">حَكّمني</h2>
            </div>
            <p className="text-gray-300 leading-relaxed text-sm md:text-base">
              منصتك الطبية الأولى في سوريا لحجز مواعيد الأطباء بسهولة وأمان.
            </p>
            <div>
              <p className="mb-3 font-semibold text-gray-200">تابعنا</p>
              <div className="flex items-center gap-4">
                {/* Social Media Icons */}
                {[
                  { Icon: BsFacebook, color: 'hover:text-blue-600' },
                  { Icon: BsTwitterX, color: 'hover:text-gray-900' },
                  { Icon: BsWhatsapp, color: 'hover:text-green-500' },
                  { Icon: BsInstagram, color: 'hover:text-pink-500' },
                  { Icon: BsLinkedin, color: 'hover:text-blue-700' }
                ].map((social, i) => (
                  <a
                    key={i}
                    href="#"
                    aria-label="Social Link"
                    className={`w-12 h-12 flex items-center justify-center bg-white/10 rounded-full text-white ${social.color} hover:bg-white transition duration-300 transform hover:scale-110`}
                  >
                    <social.Icon className="w-6 h-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-lg md:text-xl text-teal-100">روابط سريعة</h4>
            <ul className="space-y-2 text-gray-300 text-sm md:text-base">
              <li>
                <Link to="/" className="hover:text-teal-400 transition duration-300">الرئيسية</Link>
              </li>
              <li>
                <Link to="/doctors" className="hover:text-teal-400 transition duration-300">اطلب طبيبك الآن</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-teal-400 transition duration-300">من نحن</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-teal-400 transition duration-300">تواصل معنا</Link>
              </li>
            </ul>
          </div>


{/* Specializations */}
<div>
  <h4 className="font-semibold mb-4 text-lg md:text-xl text-teal-100"> التخصصات الطبية التي يقدمها حكمني </h4>
  <ul className="space-y-2 text-gray-300 text-sm md:text-base">
    {[
      "حجز عيادة طبيب",
      "حجز عيادة أسنان",
      "حجز طبيب لتقدم اسعافات ضمن المنزل",
      "حجز صيدلية",
    ].map((service, i) => (
      <li
        key={i}
        className="hover:text-teal-400 transition cursor-pointer"
      >
        {service}
      </li>
    ))}
  </ul>
</div>




          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-lg md:text-xl text-teal-100">تواصل معنا</h4>
            <ul className="space-y-3 text-gray-300 text-sm md:text-base">
              {/* Contact Icons */}
              {[
                { icon: FiPhone, text: "+963 946141654" },
                { icon: FiMail, text: "info@toiall.com" },
                { icon: FiMapPin, text: " Syria" }
              ].map((contact, i) => (
                <li key={i} className="flex items-center gap-3 transition hover:text-teal-400">
                  <div className="bg-teal-600/70 w-12 h-12 flex items-center justify-center rounded-full text-teal-100 hover:bg-teal-500 transition duration-300">
                    <contact.icon className="w-6 h-6" />
                  </div>
                  <span className="text-gray-200">{contact.text}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-6 text-center text-gray-400 text-sm md:text-base">
          <p>&copy; 2025 حَكّمني. جميع الحقوق محفوظة.</p>
          <p className="mt-1">تصميم وبرمجة toiall .</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




